import roadmapLogo from "assets/images/arts/etherium_gif.gif";
// ====================== RoadMap Sec ==================
const RoadMap = () => {
  return (
    <section id="roadMap">
        <div className="container">
          <div className="sec-heading-wrapper">
            {/* ================= Main Heading ===================== */}
            <h1 className="sec-heading" data-aos="fade-up">
              Roadmap
            </h1>
            <img
              width="230"
              height="200"
              src={roadmapLogo}
              className="roadmapLogo"
              alt=""
            />
          </div>
          <br />
          {/* =================== roadmap point start ==================== */}
          <div className="timeline" data-aos="fade-up" data-aos-duration="1500">
            {/*  */}
            <div className="container-map left">
              <div
                className="date"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                Phase
              </div>
              <strong
                className="icon fa fa-home"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                1
              </strong>
              <div
                className="content"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <p>Website Design</p>
                <p>Whitepaper + Roadmap Creation</p>
                <p>NFT Creation</p>
              </div>
            </div>
            {/*  */}
            <div className="container-map right">
              <div
                className="date"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                Phase
              </div>
              <strong
                className="icon fa fa-home"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                2
              </strong>
              <div
                className="content"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <p>Build Community + Marketing</p>
                <p>Giveaway + Whitelist Competitions</p>
                <p>Smart Contract + Dapps Creation</p>
                <p>WeStreamers NFT Collection Launch</p>
              </div>
            </div>
            {/*  */}
            <div className="container-map left">
              <div
                className="date"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                Phase
              </div>
              <strong
                className="icon fa fa-home"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                3
              </strong>
              <div
                className="content"
                data-aos="fade-right"
                data-aos-duration="2500"
              >
                <p>Development Stage of WeStream App</p>
                <p>Tokenomics Design for $STREAM Token</p>
                <p>Expanding Community Reach</p>
              </div>
            </div>
            {/*  */}
            <div className="container-map right">
              <div
                className="date"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                Phase
              </div>
              <strong
                className="icon fa fa-home"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                4
              </strong>
              <div
                className="content"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <p>Beta Testing Stage for WeStream App</p>
                <p>Create Smart Contract for $STREAM Token</p>
                <p>Token Contract Audit</p>
                <p>Marketing</p>
                <p>ICO + $STREAM Token Launch</p>
              </div>
            </div>
            {/*  */}
            <div className="container-map left">
              <div
                className="date"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                Phase
              </div>
              <strong
                className="icon fa fa-home"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                5
              </strong>
              <div
                className="content"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <p>Launch WeStream App – (iOS & Android)</p>
                <p>Coinmarketcap & Coingecko Listing</p>
                <p>Ambassador Program for Content Creators</p>
              </div>
            </div>
            {/*  */}
            <div className="container-map right">
              <div
                className="date"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                Phase
              </div>
              <strong
                className="icon fa fa-home"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                6
              </strong>
              <div
                className="content"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <p>Global Marketing Campaign</p>
                <p>Grow User Base</p>
                <p>Exchange Listings</p>
              </div>
            </div>
          </div>
          {/* =========================================== */}
        </div>
    </section>
  );
};

export default RoadMap;
